import { BaseError } from "../base/BaseError";

export class NotFoundError extends BaseError {
    message ="لم يتم العثور على الصفحة المطلوبة";
}
